import { state, getters } from "./state";
import { actions } from "./action";
import { mutations } from "./mutations";

export default {
  state,
  getters,
  actions,
  mutations,
};
